import api from "./api";
import { apiDomain } from "./constants";

export async function getPendenciesKpi() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/kpi`);

    return data;
}

export async function getPendenciesByModalities() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/modalities`);

    return data;
}

export async function getPendenciesByCategories() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/categories`);

    return data;
}

export async function getPendenciesByStates() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/states`);

    return data;
}

export async function getPendenciesByManagements() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/managements`);

    return data;
}

export async function getOldestPendenciesList({ limit = 10 } = {}) {
    const { data: { result } } = await api.get(`${apiDomain}/management-reports/pendencies`, {
        params: {
            limit,
            offset: 0,
        },
    });

    return result;
}

export async function getPendenciesCsv() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/all`, {
        responseType: "blob"
    });

    return data;
}

export async function getOnlineUsers() {
    const { data } = await api.get(`${apiDomain}/management-reports/pendencies/online-users`);

    return data && data.count;
}
